import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { getGoldenSettingsExport } from '@api/goldenSettings';

import { TGoldenSettingsOptionDTO } from '@interfaces/cmModule/dto/goldenSettingsDTO';

import { ESnackbarTypes } from '@enums/common';

import { GOLDEN_SETTING_EXPORT } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

const useMutateGoldenSettingsExport = () => {
	const dispatch = useAppDispatch();

	const {
		mutate: handleGoldenSettingsExport,
		isLoading: isLoadingGoldenSettingsExport,
	} = useMutation<TGoldenSettingsOptionDTO>({
		mutationKey: [GOLDEN_SETTING_EXPORT],
		mutationFn: getGoldenSettingsExport,
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.exportGoldenSettingsSuccess,
				type: ESnackbarTypes.success,
			}));
		},
	});

	return {
		handleGoldenSettingsExport,
		isLoadingGoldenSettingsExport,
	};
};

export default useMutateGoldenSettingsExport;
